import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type {
  UpdatePartFileRequestBody,
  UpdatePartFileRequestParams,
  UpdatePartFileResponseBody,
} from './types';

export const useUpdatePartFile: MutationFunction<
  UpdatePartFileResponseBody,
  UpdatePartFileRequestBody,
  [UpdatePartFileRequestParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { uuid } = params;
  const request = useRequest(requestOptions);
  return useMutation(
    (requestBody) => {
      return request<UpdatePartFileResponseBody>(`/parts/files/${uuid}`, {
        init: {
          method: 'PATCH',
          body: requestBody,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: 'updatePartFile',
    },
  );
};
